export enum PixStatus {
  ACTIVE = 2,

  CLEARING_REGISTRATION_PENDING = 1,

  PENDING_PORTABILITY_DICT = 3,

  AWAITING_RETURN_PSP_DONOR = 4,

  PENDING_PORTABILITY_CONFIRMATION = 5,

  USER_CONFIRMATION_PENDING_PORTABILITY = 6,

  IDENTITY_VALIDATION_PENDING = 7,

  PENDING_CLAIM_CONFIRMATION = 8,

  USER_KEY_OWNERSHIP_VALIDATION_PENDING = 9,

  CLAIM_AWAITING_RETURN_PSP_DONOR = 10,

  PENDING_VALIDATION_COMPLETE_CLAIM = 11,

  EXCLUDED = 12,

  EXPIRED = 13,

  PORTABILITY_REQUESTED = 14,

  DONATED_BY_CLAIM = 15,

  UNSUCCESSFUL_PORTABILITY = 16,

  SUCCESSFUL_PORTABILITY = 17,

  SUCCESSFUL_CLAIM = 18,

  UNSUCCESSFUL_CLAIM = 19,

  EXCLUSION_PENDING = 20,

  PENDING_DUE_TO_CLAIM = 21,

  NOT_REQUESTED_PORTABILITY = 22,

  IM_CLAIMER_AND_OWNER_GAVEAWAY_PENDING_MY_CONFIRM = 23,
}

export enum PixStatusString {
  IM_CLAIMER_PENDING_OWNER_GIVEWAY = 'IM_CLAIMER_PENDING_OWNER_GIVEWAY',
  IM_CLAIMER_AND_OWNER_GAVEAWAY_PENDING_MY_CONFIRM = 'IM_CLAIMER_AND_OWNER_GAVEAWAY_PENDING_MY_CONFIRM',
  IM_OWNER_PENDING_GIVEAWAY_CONFIRM = 'IM_OWNER_PENDING_GIVEAWAY_CONFIRM',
}
